import List from '../Site.List.i18n';
import Upload from '../Site.Upload.csv.i18n';
import Detail from '../Site.Detail.i18n';
import Language from './language';

export default {
  components: { List, Detail, Upload, Language },
  data: () => ({ base: false, list: false, detail: false, is_first : false, upload : false }),
  methods: {
    refresh() {
      if(this.$refs.list) { (this.$refs.list.$children || []).forEach(el => el.refresh()); }
    },
    // 뷰 전환
    select({ id, tag }) {
      if(id === 'csv' && !tag) { this.base = this.list = this.detail = false; this.upload = true }
      else if(!id) { this.base = this.list = !(this.upload = this.detail = false); }
      else { this.detail = !(this.upload = this.list = false); }
    }
  },
  created: function() {   console.log('site.vue', 'created'); },
  destroyed: function() { console.log('site.vue', 'destroyed'); },
  mounted: function() { console.log('site.vue', 'mounted'); this.select(this.$route.params); },
  watch: { '$route' (to, from) { console.log('site.vue', 'route changed', to.param); this.select(to.params); } },
}
